import { useFlags } from "launchdarkly-react-client-sdk";
import { useAgentsEnabledFlag } from "./use-agents-enabled-flag";

// Unlike the backend gate `isSuggestedReportsEnabled`, this doesn't check the
// `disableSuggestions` flag intentionally, as the flag should only gate
// generation.
export function useSuggestedReportsEnabled(): boolean {
  const { suggestedReports } = useFlags();
  const agentsEnabled = useAgentsEnabledFlag();
  return Boolean(suggestedReports) && agentsEnabled;
}
